<zci-tile>
    <div class="rm-info">
        <svg
            class="rm-info__icon"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 48 48"
            width="48px"
            height="48px"
        >
            <g
                id="Sprint-13-Desktop"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
            >
                <g
                    id="10---User"
                    transform="translate(-697.000000, -217.000000)"
                    fill-rule="nonzero"
                >
                    <g id="Group-6" transform="translate(697.500000, 217.000000)">
                        <g id="Group-Copy-2" fill="#E8F6F5">
                            <circle id="Oval-Copy-3" cx="24" cy="24" r="24"></circle>
                        </g>
                        <g
                            id="icon-s-/-phone"
                            transform="translate(12.255319, 12.255319)"
                            fill="#1A1A1A"
                        >
                            <path
                                d="M2.45002776,4.9144027 C6.51135293,-0.501060654 14.1936133,-1.59867081 19.6085698,2.46336353 C25.0235826,6.52544008 26.1207798,14.207505 22.0595893,19.6227888 C21.8057842,19.9612183 21.3256832,20.0298199 20.9872538,19.7760148 C20.6488243,19.5222097 20.5802227,19.0421088 20.8340278,18.7036793 C24.3876537,13.9651936 23.4275841,7.24323278 18.6893025,3.68880669 C13.951229,0.134536687 7.22927888,1.09494161 3.67558926,5.83351219 C0.122079717,10.5718426 1.08186611,17.2938847 5.81923404,20.8483404 C7.67656184,22.2413363 9.93472277,22.9939743 12.2553191,22.9930222 C15.9159692,22.9930222 17.6051519,21.5779228 17.0778937,19.2626988 C16.0567397,19.4843861 14.9573181,19.3097719 14.0179118,18.7117868 C10.7805949,16.5302077 7.99570785,13.7479745 5.79498812,10.4926869 C4.77452152,8.88029941 5.00436351,6.78073153 6.35056089,5.4332762 L6.81157778,4.97327991 L6.96959638,4.83179117 C7.70444622,4.24503595 8.77903496,4.29462059 9.45327328,4.97532247 L11.3936988,6.915748 C12.0732226,7.59527175 12.1185241,8.66889107 11.5635957,9.36411526 L11.3580155,9.59422246 C11.2642412,9.72455198 11.2781913,9.90696386 11.3937878,10.0225604 L14.5004222,13.1302161 C14.6085982,13.2383921 14.7735256,13.2564214 14.9268447,13.1601091 L15.2019811,12.9342739 C15.9394345,12.4036637 16.9596349,12.4816841 17.6081669,13.1302161 L19.5485924,15.0706416 C20.2766536,15.7987028 20.2766536,16.9791696 19.5479923,17.7078302 L19.0872286,18.1675732 C18.9054079,18.3495639 18.7097946,18.5111736 18.5034312,18.6520376 C19.4923338,22.1712443 16.9557977,24.5249391 12.2556334,24.5249391 C9.60358285,24.5260252 7.02267945,23.6658181 4.89996677,22.0737836 C-0.514152486,18.0115601 -1.61101386,10.329488 2.45002776,4.9144027 Z M7.89420507,6.05710678 L7.43344132,6.5168498 C6.5949603,7.35611518 6.4516057,8.66563523 7.07672963,9.65401936 C9.15487228,12.7273991 11.7996128,15.3696193 14.8571812,17.4303869 C15.8575716,18.066999 17.165774,17.9233569 18.0043481,17.0839996 L18.465365,16.6240033 C18.5951762,16.4941921 18.5951762,16.2836802 18.465365,16.153869 L16.5249395,14.2134435 C16.4094319,14.097936 16.2270201,14.0839859 16.145631,14.1394396 L16.0548052,14.2134435 C15.326744,14.9415047 14.145256,14.9415047 13.4171058,14.2133545 L10.3104714,11.1056988 C9.66193938,10.4571668 9.58391898,9.43696644 10.1528498,8.65057255 L10.3104714,8.4691097 C10.4402826,8.33929852 10.4402826,8.12878659 10.3104714,7.99897541 L8.36747293,6.05596465 C8.23843839,5.92569533 8.0273994,5.92483356 7.89420507,6.05710678 Z"
                                id="Color"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>

        <div class="rm-info__data c11n-text-md">
            <div *ngIf="rmContactInfo" class="c11n-space-stack-1x">
                <p class="c11n-space-stack-1x" data-cy="relationship-manager-name">
                    {{ supportTeam }}
                </p>
                <p class="c11n-space-stack-1x" data-cy="relationship-manager-email">
                    {{ email }}
                </p>
                <p
                    class="tel interstitial-phone-number-only-clickable-in-mobile"
                    (click)="callCRM()"
                    data-cy="relationship-manager-phone"
                >
                    {{ phoneNumber }}
                </p>
            </div>
            <div>{{ supportHours }}</div>
        </div>
    </div>
</zci-tile>
